function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _class, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Brick } from "zengular";
import twig from "./magic-tabs.twig";
import "./magic-tabs.scss";
import MagicTabBrick from "./magic-tab.brick";
import TabData from "../modules/tab-data";
var MagicTabsBrick = (_dec = Brick.register('magic-tabs', twig), _dec2 = Brick.listen('change-tab'), _dec(_class = (_class2 = /*#__PURE__*/function (_Brick) {
  _inherits(MagicTabsBrick, _Brick);

  var _super = _createSuper(MagicTabsBrick);

  function MagicTabsBrick() {
    _classCallCheck(this, MagicTabsBrick);

    return _super.apply(this, arguments);
  }

  _createClass(MagicTabsBrick, [{
    key: "open",
    value:
    /**
     * @param {TabData} tabData
     * @returns {*}
     */
    function open(tabData) {
      var _this = this;

      var tab = this.$$('tab').filter('[data-tab-id=' + tabData.id + ']').brick;
      if (tab) return this.go(tab);
      MagicTabBrick.create('div', true).then(function (tab) {
        tab.actor('tab');

        _this.root.append(tab.root);

        return tab.setup(tabData).then(function () {
          return tab;
        });
      }).then(function (tab) {
        tab.root.addEventListener('click', function () {
          return _this.go(tab);
        });

        _this.go(tab);
      });
    }
  }, {
    key: "__changeTab",
    value: function __changeTab(event) {
      this.go(event.data.tab);
    }
  }, {
    key: "go",
    value: function go(tab) {
      if (tab.root.classList.contains('selected')) return;
      this.$$('tab').filter('.selected').each(function (node) {
        return node.classList.remove('selected');
      });
      tab.root.classList.add('selected');
      tab.activateForm();
    }
  }]);

  return MagicTabsBrick;
}(Brick), (_applyDecoratedDescriptor(_class2.prototype, "__changeTab", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "__changeTab"), _class2.prototype)), _class2)) || _class);
export { MagicTabsBrick as default };